const BlockTimeIcon: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.92306 1.87867C7.61627 1.61206 8.38373 1.61206 9.07694 1.87867L14.0385 3.78696C14.6178 4.00976 15 4.56632 15 5.18697V11.8134C15 12.434 14.6178 12.9906 14.0385 13.2134L9.07694 15.1217C8.38373 15.3883 7.61627 15.3883 6.92306 15.1217L1.96153 13.2134C1.38224 12.9906 1 12.434 1 11.8134V5.18697C1 4.56632 1.38224 4.00976 1.96153 3.78696L6.92306 1.87867ZM8.71796 2.81202C8.25582 2.63427 7.74418 2.63427 7.28204 2.81202L5.89757 3.34451L11.4885 5.46107L13.4357 4.62655L8.71796 2.81202ZM14 5.4727L8.5 7.82984V14.2581C8.5736 14.2391 8.64637 14.2159 8.71796 14.1883L13.6795 12.28C13.8726 12.2058 14 12.0203 14 11.8134V5.4727ZM7.5 14.2581V7.82984L2 5.4727V11.8134C2 12.0203 2.12741 12.2058 2.32051 12.28L7.28204 14.1883C7.35363 14.2159 7.4264 14.2391 7.5 14.2581ZM2.56425 4.62655L8 6.95616L10.1638 6.02882L4.49652 3.88337L2.56425 4.62655Z"
        fill="#A1A6B2"
      />
    </svg>
  );
};

export default BlockTimeIcon;
